module.exports = __webpack_public_path__ + "media/my_images/vision/bg-5a0d7ab71856210b86db1adae3deb1a7.svg";